import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {EmailBanner} from '../model/email/emailBanner';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@JsonConverter
export class TsMapBannersMapConverter implements JsonCustomConvert<TSMap<string,EmailBanner>> {
    deserialize(json: any): TSMap<string,EmailBanner> {

        const temp:TSMap<string,EmailBanner>= new TSMap();

        for (const banner of json) {
            temp.set(banner.bannerName,Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(banner,EmailBanner));
        }

        return temp;
    }

    serialize(data: TSMap<any, any>): any {
        return JSON.stringify(data);
    }
}
